import {Box} from '@viptech/react-components'
import {useEffect, useState} from 'react'
import usePersonalizedThemeByCompany from 'src/hooks/usePersonalizedThemeByCompany'
import CloseIcon from 'src/images/CloseIcon'
import Dropdown from '../dropdown/Dropdown'
import {DropdownItem} from '../dropdown/DropdownProps'
import {CloseButtonFilter} from './AdvancedFiltersBase'

export type FilterSelectedFinal = {
  id: string
  label: string
  itemsOnMenu: DropdownItem[]
  selectedItem?: DropdownItem
}

export type FiltersSelected = {
  label: string
  itemsOnMenu?: DropdownItem[]
  selectedItem?: DropdownItem
}

export type AdvancedFiltersProps = {
  filtersSelected: FiltersSelected
  setFiltersSelected: (value: DropdownItem, index: number) => void
  index: number
  deleteFilter: (index: number) => void
  clearEmptyFilter?: () => void
}

export function AdvancedFilters({filtersSelected, index, setFiltersSelected, deleteFilter, clearEmptyFilter}: AdvancedFiltersProps) {
  const {styledTheme} = usePersonalizedThemeByCompany()

  const [preventEditing, setPreventEditing] = useState(false)

  const [showLabel, setShowLabel] = useState<string>(filtersSelected.selectedItem?.label ?? '')

  useEffect(() => {
    if (!filtersSelected.selectedItem || !filtersSelected.itemsOnMenu || !filtersSelected.itemsOnMenu.length) {
      setPreventEditing(true)
    }
  }, [filtersSelected])

  const handleLabel = () => {
    if (showLabel) {
      if (!filtersSelected.label.length) return filtersSelected.selectedItem?.label
      return `${filtersSelected.label}: ${filtersSelected.selectedItem?.label}`
    }
    return `${filtersSelected.label}`
  }

  useEffect(() => {
    if (filtersSelected.itemsOnMenu === undefined) {
      setFiltersSelected({id: filtersSelected.label, label: filtersSelected.label}, index)
    }
  }, [filtersSelected])

  return (
    <Box display='flex' align='center'>
      <Dropdown
        items={filtersSelected.itemsOnMenu ?? []}
        onChangeSelected={(e) => {
          if (filtersSelected.selectedItem?.label) return
          setFiltersSelected(e, index)
          setShowLabel(e.label)
        }}
        height='32px'
        hideIcon
        placeholderColor={styledTheme.advancedFilter.placeholderColor}
        iconColor={styledTheme.advancedFilter.iconColor}
        bgColor={styledTheme.advancedFilter.backgroundColor}
        borderColor={styledTheme.advancedFilter.borderColor}
        paddingLeftInsideInput='1em'
        open={!!filtersSelected.itemsOnMenu?.length}
        preventEditing={preventEditing}
        placeholder={handleLabel()}
        key={index}
        dontReflectValueSelectedOnLabel
        clickOutsideFunction={clearEmptyFilter}
        icon={
          filtersSelected.selectedItem?.label ? (
            <CloseButtonFilter onClick={() => deleteFilter(index)}>
              <CloseIcon width='10' />
            </CloseButtonFilter>
          ) : undefined
        }
      />
    </Box>
  )
}
